import React, { useState } from 'react';
import logo from '../../assets/logo.png';
import BaseStyles from '../../assets/BaseStyles';

/** Custom components */
import Rooms from '../../components/RoomList';
import ErrorMessage from '../../components/ErrorMessage';

/** Styled components */
import {
  AuctionTitle, Container, Header, Wrapper, Logo,
} from './styles';

const ControlPanel = () => {
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const { cookie } = document;

  const output = {};

  cookie.split(/\s*;\s*/).forEach((pair) => {
    pair = pair.split(/\s*=\s*/);
    output[pair[0]] = pair.splice(1).join('=');
  });

  const auctionInfo = output.streamer_auction ? JSON.parse(output.streamer_auction) : [];

  return (
    <Wrapper>
      <Header>
        <Logo src={logo} width="150" />
        <AuctionTitle>{auctionInfo?.auction}</AuctionTitle>
      </Header>
      <Container>
        {error && <ErrorMessage error={error} setError={setError} />}
          {auctionInfo && <Rooms setError={setError} setMessage={setMessage} />}
      </Container>
      <BaseStyles />
    </Wrapper>
  );
};

export default ControlPanel;
